const information = [
  {
    id: 1,
    icon: 'ub-icon-map',
    label: 'landingPage.contactsPage.address',
    text: 'landingPage.contactsPage.addressText',
  },
  {
    id: 2,
    icon: 'ub-icon-clock',
    label: 'landingPage.contactsPage.timing',
    text: '10:00 — 20:00',
  },
  {
    id: 3,
    icon: 'ub-icon-email',
    label: 'E-mail:',
    text: 'support@upperbs.com',
    link: 'mailto:support@upperbs.com',
  },
  {
    id: 4,
    icon: 'ub-icon-phone',
    label: 'landingPage.contactsPage.phone',
    text: '+971 52 184 1181',
    link: 'tel:+971521841181',
  },
];

export default information;
